module.exports = __webpack_public_path__ + "media/images/brand-c40a90d9055479f406c820aea0a953fe.svg";